<template>
  <div v-if="!userReviewed">
    <div>
      <CustomFdkAccount v-slot="accountsData">
        <JdsButton
          :fullWidth="true"
          variant="secondary"
          size="large"
          @click="openAddReviewModal(accountsData)"
        >
          Write a Review
        </JdsButton>
      </CustomFdkAccount>
    </div>
  </div>
</template>

<script>
  // import StarRating from "@/components/DesignSystem/StarRating/StarRating.vue"
  import CustomFdkAccount from "@/components/Utilities/CustomFdkAccount/CustomFdkAccount.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import AddEditReview from "@/components/ReviewAndRating/AddEditReview/AddEditReview.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import { customerLoginHandler } from "@/utils/utils"

  export default {
    name: "RatingCta",
    components: { CustomFdkAccount, JdsButton },
    mixins: [modalMixin],
    inject: ["globalState"],
    computed: {
      userReviewed() {
        return !this.globalState.userReviewed
      },
      rating() {
        return this.globalState.rating || 0
      },
    },
    methods: {
      openAddReviewModal(accountsData, selectedStar) {
        if (!accountsData.is_logged_in) {
          customerLoginHandler(accountsData)
        } else {
          this.openModal(AddEditReview, {
            selectedRating: selectedStar || 0,
          })
        }
      },
    },
  }
</script>
